module.exports = __webpack_public_path__ + "static/media/sports.8cecebf5.svg";